import { useTranslation } from 'react-i18next';
import { formatRemaining, phaseLabelKey, phaseProgress, type PhaseResult } from '@/lib/task-phase';
import styles from './CountdownRing.module.css';

/**
 * GERI SAYIM HALKASI.
 *
 * Sayi TEK BASINA yeterli degil: kullanicinin bakmadan da "az kaldi mi" sorusunu
 * cevaplayabilmesi gerekiyor. Halka bunu renk + doluluk ile anlatiyor, ortadaki
 * mm:ss ise kesin degeri veriyor.
 *
 * SVG dasharray ile cizildi (canvas / JS animasyon yok): saniyede bir degisen
 * bir deger icin tarayicinin kendi cizimi fazlasiyla yeterli ve tema
 * degisiminde renk bedavaya dogru gelir.
 *
 * Erisilebilirlik: halkanin kendisi dekoratif; kalan sure metin olarak da
 * basiliyor ve `role="timer"` ile duyuruluyor. `aria-live` YOK — saniyede bir
 * konusan bir ekran okuyucu, ekrandaki her seyin ustune biner.
 */

const SIZE = 44;
const STROKE = 2.5; // mobil RingCountdown ile ayni incelik
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function CountdownRing({
  phase,
  taskStatusCode,
}: {
  phase: PhaseResult;
  /** Duyurulan metin faz rozetiyle AYNI olsun diye (payment_received -> "Gonderim Bekliyor"). */
  taskStatusCode?: string | null | undefined;
}) {
  const { t } = useTranslation();
  if (phase.phase === 'passive') return null;

  const progress = phaseProgress(phase);
  const label = formatRemaining(phase.remainingMs);

  return (
    <div
      className={[styles.ring, styles[phase.phase]].join(' ')}
      role="timer"
      aria-label={`${t(phaseLabelKey(phase.phase, taskStatusCode))} ${label}`}
    >
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${String(SIZE)} ${String(SIZE)}`} aria-hidden="true">
        {/* Ilerleme yayi foil'in parlak ucundan faz rengine akar (mobil:
            RingCountdown). Ayni faz icin id tekrar eder; tarayici ilk tanimi
            kullanir ve hepsi ozdes oldugundan sorun cikmaz. */}
        <defs>
          <linearGradient id={`ringFoil-${phase.phase}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" className={styles.stopStart} />
            <stop offset="1" className={styles.stopEnd} />
          </linearGradient>
        </defs>
        <circle
          className={styles.track}
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          strokeWidth={STROKE}
          fill="none"
        />
        <circle
          className={styles.progress}
          stroke={`url(#ringFoil-${phase.phase})`}
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          strokeWidth={STROKE}
          fill="none"
          strokeDasharray={CIRCUMFERENCE}
          // Kalan sure kadar dolu: gecen sure boslugu acar.
          strokeDashoffset={CIRCUMFERENCE * progress}
          strokeLinecap="round"
        />
      </svg>
      <span className={styles.value}>{label}</span>
    </div>
  );
}
